import script from "./WhatsappBusinessAccountView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsappBusinessAccountView.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsappBusinessAccountView.vue?vue&type=style&index=0&id=9960f3e8&scoped=true&lang=scss"

import exportComponent from "../../../../../home/franc/adereso-bsp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9960f3e8"]])

export default __exports__